import React from 'react';
import "./list.css";
import { List } from '../data/Data';
import FavoriteIcon from '@mui/icons-material/Favorite';
import Button from '@mui/material/Button';
import LocationOnIcon from '@mui/icons-material/LocationOn';
function list() {
    return (
        <section className='paddings flexDisplay listSection'>
            <h1 className='primaryText'>Recent Property Listed</h1>
            <p className='secondaryText'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor<br />
                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
            <div className="allListContainer">
                {List.map((item, index) => (
                    <div className='onlyListCarde' key={index}>
                        <img src={item.cover} alt={item.name} />
                        <div className="headerInfo">
                           <span className={item.category === "For Sale" ? "sale" : "rent"}>
                                {item.category}
                            </span>

                            <FavoriteIcon className='primaryText' />
                        </div>
                        <h1 className="xl:text-xl text-base capitalize font-medium">{item.name}</h1>
                        <h3 className="secondaryText"><LocationOnIcon />{item.location}</h3>
                        <div className="southContent">
                            <div className="leftContent">
                                <Button variant="contained">{item.price}</Button>
                                <span className='secondaryText'>/sqft</span>
                            </div>
                            <h2 className='xl:text-lg text-sm capitalize font-medium'>{item.type}</h2>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default list
